<template>
  <AvailabilityInformation
    v-if="articleNumber"
    v-bind="props"
  >
    <template
      v-if="!availability?.stock"
      #delivery-availability-mail
    >
      <DeliveryAvailabilityMailContainer :article-number="articleNumber" />
    </template>
  </AvailabilityInformation>
</template>

<script setup lang="ts">
import { AvailabilityInformation } from '@i22team/td-longtail-vue-components';
import DeliveryAvailabilityMailContainer from '~/components/product-detail/delivery-availability-mail-container.vue';

export type AvailabilityInformationContainerProps = {
  articleNumber?: string;
  availability?: NonNullable<NonNullable<Offer['product']>['availability']>;
};

const props = withDefaults(defineProps<AvailabilityInformationContainerProps>(), {
  articleNumber: undefined,
  availability: undefined,
});
</script>
